import { SVGIconType } from '../../models/enums'
import { ReactComponent as ChevronRightIcon } from '../../assets/images/chevron-right.svg'
import { ReactComponent as ChevronLeftIcon } from '../../assets/images/chevron-left.svg'
import { ReactComponent as DoctorUserIcon } from '../../assets/images/doctor-user.svg'
import { ReactComponent as LocationCrossIcon } from '../../assets/images/location-crosshairs.svg'
import { ReactComponent as EditPenIcon } from '../../assets/images/edit-pen.svg'
import { ReactComponent as CloseIcon } from '../../assets/images/close.svg'
import { ReactComponent as FilterIcon } from '../../assets/images/filter.svg'
import { ReactComponent as CheckMarkIcon } from '../../assets/images/checkmark.svg'
import { ReactComponent as CalendarEdit } from '../../assets/images/calendar-edit.svg'
import { ReactComponent as AppleIcon } from '../../assets/images/brands/apple.svg'
import { ReactComponent as GoogleIcon } from '../../assets/images/brands/google.svg'
import { ReactComponent as OutlookIcon } from '../../assets/images/brands/outlook.svg'
import { ReactComponent as YahooIcon } from '../../assets/images/brands/yahoo.svg'
import { ReactComponent as MyBookingsIcon } from '../../assets/images/my-bookings.svg'
import { ReactComponent as BankIDIcon } from '../../assets/images/bank-id.svg'
import { ReactComponent as TreatmentIcon } from '../../assets/images/treatment-icon.svg'
import { ReactComponent as ClinicIcon } from '../../assets/images/clinic.svg'
import { ReactComponent as PhoneIcon } from '../../assets/images/phone-icon.svg'
import { ReactComponent as CloseCircleIcon } from '../../assets/images/close-circle-icon.svg'
import { ReactComponent as InfoIcon } from '../../assets/images/info-icon.svg'
import { ReactComponent as ClockIcon } from '../../assets/images/clock.svg'
import { ReactComponent as DoubleChevronLeftIcon } from '../../assets/images/double-chevron-left-icon.svg'
import { ReactComponent as ArrowRightIcon } from '../../assets/images/arrow-right.svg'
import { ReactComponent as StarIconIcon } from '../../assets/images/star-icon.svg'
import { ReactComponent as ProfileIcon } from '../../assets/images/profile-icon.svg'

export interface SVGIconProps extends React.SVGProps<SVGSVGElement> {
  icon: SVGIconType
}

const SVGIcon = ({ icon, ...props }: SVGIconProps) => {
  switch (icon) {
    case SVGIconType.ChevronRight:
      return <ChevronRightIcon {...props} />

    case SVGIconType.ChevronLeft:
      return <ChevronLeftIcon {...props} />

    case SVGIconType.DoctorUser:
      return <DoctorUserIcon {...props} />

    case SVGIconType.LocationCross:
      return <LocationCrossIcon {...props} />

    case SVGIconType.EditPen:
      return <EditPenIcon {...props} />

    case SVGIconType.Close:
      return <CloseIcon {...props} />

    case SVGIconType.Filter:
      return <FilterIcon {...props} />

    case SVGIconType.CheckMark:
      return <CheckMarkIcon {...props} />

    case SVGIconType.CalendarEdit:
      return <CalendarEdit {...props} />

    case SVGIconType.Apple:
      return <AppleIcon {...props} />

    case SVGIconType.Google:
      return <GoogleIcon {...props} />

    case SVGIconType.Outlook:
      return <OutlookIcon {...props} />

    case SVGIconType.Yahoo:
      return <YahooIcon {...props} />

    case SVGIconType.MyBookings:
      return <MyBookingsIcon {...props} />

    case SVGIconType.BankID:
      return <BankIDIcon {...props} />

    case SVGIconType.Clinic:
      return <ClinicIcon {...props} />

    case SVGIconType.Treatment:
      return <TreatmentIcon {...props} />

    case SVGIconType.Phone:
      return <PhoneIcon {...props} />

    case SVGIconType.CloseCircle:
      return <CloseCircleIcon {...props} />

    case SVGIconType.Info:
      return <InfoIcon {...props} />

    case SVGIconType.Clock:
      return <ClockIcon {...props} />

    case SVGIconType.DoubleChevronLeft:
      return <DoubleChevronLeftIcon {...props} />

    case SVGIconType.ArrowRight:
      return <ArrowRightIcon {...props} />

    case SVGIconType.StarIcon:
      return <StarIconIcon {...props} />

    case SVGIconType.ProfileIcon:
      return <ProfileIcon {...props} />

    default:
      return null
  }
}

export default SVGIcon
